export const FETCH_LMS_COURSES_REQUEST = 'courses/FETCH_LMS_COURSES_REQUEST';
export const FETCH_LMS_COURSES_SUCCESS = 'courses/FETCH_LMS_COURSES_SUCCESS';
export const FETCH_LMS_COURSES_FAILURE = 'courses/FETCH_LMS_COURSES_FAILURE';
